const getUpdatedValue = (changedValue, value) => changedValue || null;

const isMatch = (newsitem, value) => value === null || parseInt(value, 10) === newsitem.category || newsitem.category.includes( parseInt(value, 10) );

const isSet = (value) => value !== null;

export default {
	getUpdatedValue,
	isMatch,
	isSet
};
